import { REDUCER_KEY_STRUCTURE_EDITOR } from './constants';

export function structureEditorState(state) {
  return state.get(REDUCER_KEY_STRUCTURE_EDITOR);
}

export function currentEditor(state) {
  return structureEditorState(state).get('currentEditor');
}

export function structure(state) {
  return structureEditorState(state).get('structure');
}

export function structureName(state) {
  return structureEditorState(state).get('structureName');
}

export function structureInsertMode(state) {
  return structureEditorState(state).get('structureInsertMode');
}

export function changeStructureTriggerUid(state) {
  return structureEditorState(state).get('changeStructureTriggerUid');
}
